export const NUMBER_REG_EXP = /\B(?=(\d{3})+(?!\d))/g;

const padZero = (num, size) => {
  let s = String(Math.trunc(num));
  while (s.length < size) {
    s = `0${s}`;
  }
  return s;
};

export const formatSeconds = num => {
  const minutes = padZero(Math.floor(num / 60), 2);
  const seconds = padZero(num % 60, 2);
  return `${minutes}:${seconds}`;
};

export const numberFormat = num => {
  const parts = num.toString().split('.');
  parts[0] = parts[0].replace(NUMBER_REG_EXP, ',');
  return parts.join('.');
};
